import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useParams } from "react-router-dom";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import { useDispatch } from "react-redux";
import apiServiceHandler from "../../service/apiService";
import { updateRefreshCardData } from "../../redux/dripData";

const MessageModal = ({ isOpen, onClose, cardData }) => {
  const [body, setBody] = useState("");
  const [subject, setSubject] = useState("")
  const {id} = useParams()
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen && cardData?.message) {
      setBody(cardData?.message?.body || "");
      setSubject(cardData?.message?.subject || "");
    }
  },[isOpen, cardData])

  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    ["link", "image", "video", "formula"],

    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],

    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],

    ["clean"],
  ];

  const module = {
    toolbar: toolbarOptions,
  };

  const updateMessageData = async () => {
    const payload = {
      body: body,
      subject: subject
    };

    try {
      const response = await apiServiceHandler(
        "PATCH",
        `api/drip-compaign/${id}`,
        { message: payload }
      );
      if (response?.status) {
        toastr.success(response?.message);
        dispatch(updateRefreshCardData(true));
        onClose();
      }
    } catch (error) {
      console.error("Failed to update trigger:", error);
      toastr.error("Failed to update trigger. Please try again.");
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title
          style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
        >
          <svg
            viewBox="0 0 19 20"
            xmlns="http://www.w3.org/2000/svg"
            className="menu-icon__svg"
            preserveAspectRatio="xMidYMid meet"
            style={{ width: "20px", height: "20px" }}
          >
            <path d="M3.25 0A3.254 3.254 0 000 3.25v11.018a1.246 1.246 0 001.251 1.25c.259 0 .516-.08.734-.239L6.493 12h6.257A3.254 3.254 0 0016 8.75v-5.5A3.254 3.254 0 0012.75 0h-9.5zM17 4.01v4.74A4.253 4.253 0 0112.75 13H6.82l-2.225 1.615A3.245 3.245 0 007.25 16h6.255l4.51 3.28a1.242 1.242 0 001.3.1c.425-.21.685-.64.685-1.11V7.25a3.258 3.258 0 00-3-3.24z"></path>
          </svg>
          <span>Message</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields" style={{ maxWidth: "100%" }}>
          <div className="invite-form__field">
            <div className="text-input__label">Subject</div>
            <div className="form-input__wrapper">
              <input type="text" className="form-input__input" value={subject} onChange={(e) => setSubject(e.target.value)} />
            </div>
          </div>
          <div className="invite-form__field">
            <div className="text-input__label">Body</div>
            <div className="form-input__wrapper">
              {/* <textarea type="text" className="form-input__input" /> */}
              <ReactQuill
                modules={module}
                theme="snow"
                value={body}
                onChange={setBody}
                style={{ width: "100%", height: "400px", overflowY: 'scroll', padding: '8px 0' }} // Adjust height
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: "1rem" }}>
        <button className="send-invite__btn" style={{ background: "#fff" }}>
          <span className="send-invite-button__label">Delete</span>
        </button>
        <button className="send-invite__btn" onClick={updateMessageData}>
          <span className="send-invite-button__label">Save</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MessageModal;
